import { Component, AfterViewInit } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { NotificationPresenter } from './notification.presenter';
import { AbstractView } from '@core/interfaces/abstract-view';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [SharedModule],
  providers: [MessageService],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent
  extends AbstractView<NotificationPresenter>
  implements AfterViewInit
{
  notification$ = this.presenter.notification$;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: NotificationPresenter
  ) {
    super(messageService, router, store, presenter);
  }

  ngAfterViewInit(): void {
    this.presenter.setView(this);
  }
}
